import { gql } from '@apollo/client';
import orgsAndUnitsFragment from '@shared/queries/orgsAndUnitsFragment';
import observationReportDocumentFragment from './observationReportDocumentFragment';

const GET_OBSERVATION_REPORT_DOCUMENTS = gql`
  query GetObservationReportDocuments($eventId: Int!, $observedUserId: Int!) {
    observationReports(eventId: $eventId, observedUserId: $observedUserId) {
      ...ObservationReportFields
    }

    observationReportEventOrgWithOrgUnits(eventId: $eventId, observedUserId: $observedUserId) {
      ...OrgAndUnitsFields
    }
  }
  ${observationReportDocumentFragment}
  ${orgsAndUnitsFragment}
`;

export default GET_OBSERVATION_REPORT_DOCUMENTS;
